module.exports = __webpack_public_path__ + "static/media/delete.b383b6ae.svg";